import React, { useState } from 'react';
import { Hash, Sparkles } from 'lucide-react';

const EmployeeIdConfigForm = ({ config, onSubmit, onCancel, loading }) => {
  const [prefix, setPrefix] = useState(config?.prefix || '');
  const [sequence, setSequence] = useState(config?.currentSequence ?? 0);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      prefix: prefix.toUpperCase(),
      currentSequence: Number(sequence)
    });
  };

  const previewNextId = `${prefix.toUpperCase() || 'PREFIX-'}${String(Number(sequence) + 1).padStart(4, '0')}`;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-slate-600 mb-1.5">Static Employee ID Prefix *</label>
        <div className="relative">
          <Hash className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <input
            type="text"
            required
            value={prefix}
            onChange={(e) => setPrefix(e.target.value.toUpperCase())}
            placeholder="e.g. ABC-EMP-"
            className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition font-mono uppercase"
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-medium text-slate-600 mb-1.5">Current Sequence Counter</label>
        <input
          type="number"
          min="0"
          value={sequence}
          onChange={(e) => setSequence(e.target.value)}
          className="w-full px-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition font-mono"
        />
      </div>

      {/* Live Preview Box */}
      <div className="p-4 rounded-2xl bg-green-950/20 border border-green-600/20">
        <div className="flex items-center space-x-2 text-green-700 font-semibold text-xs mb-1">
          <Sparkles className="w-4 h-4" />
          <span>Live Next ID Preview</span>
        </div>
        <p className="text-xl font-mono font-bold text-slate-900 tracking-widest mt-1">{previewNextId}</p>
        <p className="text-[11px] text-slate-500 mt-1">
          When the company admin adds their next employee, this exact ID will be generated atomically.
        </p>
      </div>

      <div className="flex items-center justify-end space-x-3 pt-4 border-t border-slate-100">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 rounded-xl text-xs font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 transition"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-2 rounded-xl text-xs font-semibold text-white bg-green-700 hover:bg-green-600 shadow-lg shadow-green-700/30 disabled:opacity-50 transition"
        >
          {loading ? 'Saving...' : 'Save Configuration'}
        </button>
      </div>
    </form>
  );
};

export default EmployeeIdConfigForm;
